export default {
  sent: 'Sent invoices:',
  treatPending: 'Invoices pending to be treated',
  sentPending: 'Invoices pending to be sent',
  max: 'maximum',
  barChart: 'Exchanged invoices',
  pieChart: 'Invoices status'
}
